<template>
	<section class="container">
		<div class="lay">
			<popup @close="$router.back()">
				<div class="frame">
					<div class="frame-label">Регистрация</div>
					<register @submit="submit"></register>
					<agreement></agreement>
				</div>
			</popup>
		</div>
	</section>
</template>

<script>
import register from '@/components/register.vue';
import agreement from '@/components/agreement.vue';

export default {
	components: { agreement, register },
	async fetch({ store, route }) {
		return await store.dispatch('init', { route });
	},
	methods: {
		submit(data) {
			this.$store
				.dispatch('api/send', {
					task: 'register',
					data,
				})
				.then(() => {
					this.$store.dispatch('checkPromo', this.$route);
					this.$router.push('/profile');
				});
		},
	},
};
</script>
